module.exports = __webpack_public_path__ + "img/square-h.24ded37c.svg";